import { jsx } from "react/jsx-runtime";
import { getSvgProps } from "./Icon.js";
import Dark from "../svgs/medium/envelope/Dark.js";
const IconEnvelopeDark = (iconProps)=>/*#__PURE__*/ jsx(Dark, {
        ...getSvgProps(iconProps)
    });
export { IconEnvelopeDark };
